import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Search } from "react-bootstrap-table2-toolkit";
import moment from "moment";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { getActivityLogRounds } from "store/registrationdmin-history/actions";
import { isEmpty, size } from "lodash";
import "assets/scss/table.scss";
import { use } from "react";

class MsgsList extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      activitylogRounds: [],
      modal: false,
      deleteModal: false,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { onGetActivityLogRounds } = this.props;
    // Get 'id' from route params
    const id = this.props.match.params.id;
    const { user_id } = this.state;

    if (id) {
      // Pass both id and type to the action
      onGetActivityLogRounds(id, user_id);
    } else {
      console.error("ID  missing in the request.");
    }
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  componentDidUpdate(prevProps) {
    const { activitylogRounds } = this.props;
    if (
      !isEmpty(activitylogRounds) &&
      size(prevProps.activitylogRounds) !== size(activitylogRounds)
    ) {
      this.setState({ activitylogRounds: {}, isEdit: false });
    }
  }

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  render() {
    const { SearchBar } = Search;
    const { activitylogRounds } = this.props;
    const { isEdit, deleteModal } = this.state;
    const schemeName = this.props.activitylogRounds?.[0]?.scheme_name || "";
    const roundNo = this.props.activitylogRounds?.[0]?.round_no || "";
    const pageOptions = {
      sizePerPage: 10,
      totalSize: activitylogRounds ? activitylogRounds.length : 0,
      custom: true,
    };
    const defaultSorted = [
      {
        dataField: "id",
        order: "desc",
      },
    ];

    const extractStatus = text => {
      if (!text) return "";

      // example: "status: Open" => Open
      const match = text.match(/status:\s*([^,]+)/i);
      return match ? match[1].trim() : "";
    };

    const hasStatus = text => {
      return text?.toLowerCase().includes("status:");
    };

    const statusColors = {
      Created: "#067a8c",
      Ready: "#e66a05",
      Open: "#088525",
      Closed: "#b80e1f",
      "Report Available": "#0d2194",
    };

    const isParticipantsText = text => {
      return text?.toLowerCase().includes("participants");
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title> History | Rounds</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            {/* <Breadcrumbs title="History" breadcrumbItem="Activity Log" /> */}

            <h5 className="mb-4">
              <span style={{ fontWeight: "bold", textTransform: "uppercase" }}>
                ACTIVITY LOG
              </span>{" "}
              <span style={{ color: "#6c757d", fontWeight: "bold" }}>-</span>{" "}
              <span style={{ color: "#0a68cc", fontWeight: "bold" }}>
                {schemeName}
              </span>{" "}
              <span style={{ color: "#6c757d" }}>(Round </span>
              <span style={{ color: "#28a745", fontWeight: "bold" }}>
                {roundNo}
              </span>
              <span style={{ color: "#6c757d" }}>)</span>
            </h5>
            <Row>
              <Col lg="8" className="offset-lg-2">
                <Card className="mb-2 d-flex justify-content-center">
                  <CardBody>
                    {!isEmpty(this.props.activitylogRounds) &&
                      this.props.activitylogRounds.map(
                        (activitylogRounds, key) => {
                          let cardBgColor = "#f8f9fa"; // default light

                          if (activitylogRounds.actions === "Updated") {
                            cardBgColor = "rgba(40, 167, 69, 0.1)";

                            // Participants update special background
                            if (
                              isParticipantsText(activitylogRounds.new_value)
                            ) {
                              cardBgColor = "#e9e9e9";
                            }
                          } else if (activitylogRounds.actions === "Added") {
                            cardBgColor = "#e9e9e9";
                          } else if (activitylogRounds.actions === "Deleted") {
                            cardBgColor = "#f8d7da"; // light red
                          }
                          // Determine the status color
                          const statusColor =
                            statusColors[activitylogRounds.status] || "gray"; // Default color

                          return (
                            <Card
                              key={"_card_" + key}
                              className="mb-3 shadow-sm"
                              style={{
                                backgroundColor: cardBgColor,
                                borderRadius: "10px",
                              }}
                            >
                              <CardBody className="p-3">
                                <div
                                  style={{
                                    marginBottom: "10px",
                                    fontSize: "12px",
                                    color: "#6c757d",
                                  }}
                                >
                                  {moment(
                                    activitylogRounds.actions === "Updated"
                                      ? activitylogRounds.date_of_updation
                                      : activitylogRounds.date_of_addition
                                  ).format("DD-MMM-YY, h:mm A")}
                                </div>

                                {activitylogRounds.actions === "Updated" && (
                                  <div>
                                    <b style={{ fontWeight: "bold" }}>
                                      {activitylogRounds.added_by}
                                    </b>{" "}
                                    <span style={{ color: "#000" }}>
                                      Updated
                                    </span>{" "}
                                    from {/* OLD VALUE */}
                                    {hasStatus(activitylogRounds.old_value) ? (
                                      <>
                                        <span style={{ color: "#000" }}>
                                          status:
                                        </span>{" "}
                                        <b
                                          style={{
                                            color:
                                              statusColors[
                                                extractStatus(
                                                  activitylogRounds.old_value
                                                )
                                              ] || "#000",
                                          }}
                                        >
                                          {extractStatus(
                                            activitylogRounds.old_value
                                          )}
                                        </b>
                                      </>
                                    ) : (
                                      <b style={{ color: "#000" }}>
                                        {activitylogRounds.old_value}
                                      </b>
                                    )}{" "}
                                    to {/* NEW VALUE */}
                                    {hasStatus(activitylogRounds.new_value) ? (
                                      <>
                                        <span style={{ color: "#000" }}>
                                          status:
                                        </span>{" "}
                                        <b
                                          style={{
                                            color:
                                              statusColors[
                                                extractStatus(
                                                  activitylogRounds.new_value
                                                )
                                              ] || "#000",
                                          }}
                                        >
                                          {extractStatus(
                                            activitylogRounds.new_value
                                          )}
                                        </b>
                                      </>
                                    ) : isParticipantsText(
                                        activitylogRounds.new_value
                                      ) ? (
                                      <b style={{ color: "#525252" }}>
                                        {activitylogRounds.new_value}
                                      </b>
                                    ) : (
                                      <b style={{ color: "#000" }}>
                                        {activitylogRounds.new_value}
                                      </b>
                                    )}{" "}
                                    {/* 
                                    at{" "}
                                    {moment(activitylogRounds.date_of_updation).format("DD-MMM-YY, h:mm A")}{" "} */}
                                    with Round ID{" "}
                                    <b>{activitylogRounds.round_id}</b>
                                  </div>
                                )}
                                {activitylogRounds.actions === "Added" && (
                                  <div>
                                    <b>{activitylogRounds.added_by}</b>{" "}
                                    <span style={{ color: "#000" }}>Added</span>{" "}
                                    a Round{" "}
                                    <span style={{ color: "#000" }}>
                                      status:
                                    </span>{" "}
                                    <b
                                      style={{
                                        color:
                                          statusColors[
                                            extractStatus(
                                              activitylogRounds.new_value
                                            )
                                          ] || "#000",
                                      }}
                                    >
                                      {extractStatus(
                                        activitylogRounds.new_value
                                      )}
                                    </b>{" "}
                                    {/* at{" "}
                                    {moment(activitylogRounds.date_of_addition).format("DD-MMM-YY, h:mm A")}{" "} */}
                                    with Round ID{" "}
                                    <b>{activitylogRounds.round_id}</b>.
                                  </div>
                                )}
                              </CardBody>
                            </Card>
                          );
                        }
                      )}

                    {isEmpty(this.props.activitylogRounds) && (
                      <Row>
                        <Col lg="12">
                          <div className=" mb-5">
                            <h5 className="text-uppercase">
                              No Comments exists.....
                            </h5>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

MsgsList.propTypes = {
  match: PropTypes.object,
  activitylogRounds: PropTypes.array,
  className: PropTypes.any,
  onGetActivityLogRounds: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = ({ activitylogRounds }) => ({
  activitylogRounds: activitylogRounds.activitylogRounds,
});

const mapDispatchToProps = dispatch => ({
  onGetActivityLogRounds: (id, user_id) =>
    dispatch(getActivityLogRounds(id, user_id)), // Pass id and type here
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MsgsList));
